import { TipoDocumentoCidadaoEnum } from 'graphql/types.generated'

import { DocumentoAssociadoFormModel, DocumentoGerenciavelFormModel } from './types/model-cidadao'

export interface DocumentosCidadaoGerenciados {
  cpf: string | null
  cns: string | null
  documentosAssociados: DocumentoAssociadoFormModel[]
}

export const getDocumentosGerenciaveis = (
  documentosAssociados: DocumentoAssociadoFormModel[] = [],
  cpf?: string | null,
  cns?: string | null
): DocumentoGerenciavelFormModel[] => {
  const documentosAtuais = [
    { documento: cpf, tipoDocumento: TipoDocumentoCidadaoEnum.CPF },
    { documento: cns, tipoDocumento: TipoDocumentoCidadaoEnum.CNS },
  ]

  const isDocumentoAtual = (doc: DocumentoAssociadoFormModel) =>
    documentosAtuais.some((atual) => atual.tipoDocumento === doc.tipoDocumento && atual.documento === doc.documento)

  const documentosDaBase = documentosAssociados.map((doc) => {
    const stPrincipal = isDocumentoAtual(doc)
    return { ...doc, stPrincipal, stRemovido: stPrincipal ? false : doc.stRemovido }
  })

  const documentosNovos = documentosAtuais.flatMap(({ documento, tipoDocumento }) =>
    documento && !documentosAssociados.some((doc) => doc.tipoDocumento === tipoDocumento && doc.documento === documento)
      ? [{ documento, tipoDocumento, permissaoExclusao: { enabled: true }, stRemovido: false, stPrincipal: true }]
      : []
  )

  return [...documentosDaBase, ...documentosNovos]
}

export const toggleDocumentoPrincipal = (
  documentos: DocumentoGerenciavelFormModel[],
  documento: string
): DocumentoGerenciavelFormModel[] => {
  const tipoDocumento = documentos.find((doc) => doc.documento === documento)?.tipoDocumento

  const alternarPrincipal = (doc: DocumentoGerenciavelFormModel): DocumentoGerenciavelFormModel =>
    doc.stPrincipal ? { ...doc, stPrincipal: false } : { ...doc, stPrincipal: true, stRemovido: false }

  const removerPrincipalMesmoTipo = (doc: DocumentoGerenciavelFormModel): DocumentoGerenciavelFormModel =>
    doc.tipoDocumento === tipoDocumento ? { ...doc, stPrincipal: false } : doc

  return documentos.map((doc) =>
    doc.documento === documento ? alternarPrincipal(doc) : removerPrincipalMesmoTipo(doc)
  )
}

export const toggleDocumentoRemovido = (
  documentos: DocumentoGerenciavelFormModel[],
  documento: string
): DocumentoGerenciavelFormModel[] =>
  documentos.map((doc) =>
    doc.documento === documento && doc.permissaoExclusao.enabled
      ? { ...doc, stPrincipal: false, stRemovido: !doc.stRemovido }
      : doc
  )

export const applyDocumentosGerenciados = (
  documentosAssociados: DocumentoAssociadoFormModel[],
  documentosGerenciados: DocumentoGerenciavelFormModel[]
): DocumentosCidadaoGerenciados => {
  const getPrincipal = (tipoDocumento: TipoDocumentoCidadaoEnum) =>
    documentosGerenciados.find((doc) => doc.tipoDocumento === tipoDocumento && doc.stPrincipal)?.documento ?? null

  const getStRemovido = (doc: DocumentoAssociadoFormModel) =>
    documentosGerenciados.find((gerenciado) => gerenciado.documento === doc.documento)?.stRemovido ?? doc.stRemovido

  return {
    cpf: getPrincipal(TipoDocumentoCidadaoEnum.CPF),
    cns: getPrincipal(TipoDocumentoCidadaoEnum.CNS),
    documentosAssociados: documentosAssociados.map((doc) => ({ ...doc, stRemovido: getStRemovido(doc) })),
  }
}
